import * as React from "react";
import { Loader, Header } from "semantic-ui-react";
import { mean } from "lodash";
import { isRequestActive } from "redux-request-loading";
import { connect } from "react-redux";

import { VisualSummary } from "@teamprevent/common/stressRiskAssessment/components/VisualSummary";
import { TeamSraQuestionnaireResultModel } from "@teamprevent/common/stressRiskAssessment//models";

import { LOAD_TEAM_SRA_RESULTS } from "../actionTypes";
import { ApplicationState } from "../../applicationState";
import { loadTeamSraResults } from "../actions";
import "../styles/sra-summary.scss";

import { AllDepartmentsOption } from "./DepartmentFilter";

interface OwnProps {
    departmentId?: string;
}

interface StateProps {
    teamSraResults: TeamSraQuestionnaireResultModel;
    loading: boolean;
}

interface DispatchProps {
    loadTeamSraResults: (departmentId?: string) => void;
}

type Props = OwnProps & StateProps & DispatchProps;

export const TeamSraSummaryUnconnected: React.FunctionComponent<Props> = (props: Props) => {
    const [prevDepartmentId, setPrevDepartmentId] = React.useState(AllDepartmentsOption);

    React.useEffect(() => {
        props.loadTeamSraResults("");
        setPrevDepartmentId(props.departmentId);
    }, []);

    React.useEffect(() => {
        if (props.departmentId && prevDepartmentId !== props.departmentId) {
            setPrevDepartmentId(props.departmentId);
            if (props.departmentId === AllDepartmentsOption) {
                props.loadTeamSraResults("");
            } else {
                props.loadTeamSraResults(props.departmentId);
            }
        }
    }, [props.departmentId]);

    if (props.loading || !props.teamSraResults) {
        return <Loader active>Loading</Loader>;
    }

    return (
        <>
            {!props.teamSraResults?.totalSurveys || props.teamSraResults.totalSurveys < 1
                ? (<div className="no-results-text">
                    You currently have no completed Stress Risk Assessment Questionnaires to view.
                    Please click on Create New Stress Risk Assessment to get started.
                </div>)
                :
                (<>
                    <Header className="" as="h4">Total number of surveys completed: {props.teamSraResults.totalSurveys}</Header>
                    <VisualSummary questionnaireResult={props.teamSraResults as TeamSraQuestionnaireResultModel} />
                    <div className="sra-summary-team-text">
                        <p>
                            <strong>Overall team results are calculated as a mean average of all the surveys completed.</strong>
                        </p>
                    </div>
                </>)
            }
        </>
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => {

    const teamSraResults = state.teamSraResults;

    if (teamSraResults !== null && teamSraResults.questionnaireScores !== null) {
        teamSraResults.overallScore = mean(teamSraResults.questionnaireScores.map(q => q.meanScore));
    }

    return {
        teamSraResults,
        loading: isRequestActive(state, LOAD_TEAM_SRA_RESULTS)
    };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    loadTeamSraResults: (departmentId?: string) => dispatch(loadTeamSraResults(departmentId)),
});

export const TeamSraSummary = connect(mapStateToProps, mapDispatchToProps)(TeamSraSummaryUnconnected);
